import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import VideoBox from './videoBox';

import NewsList from './newsList';

class AreaReports extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.areaReports}>
                <div className={styles.leftwrap}>
                    <VideoBox content={content.videos} />
                </div>
                <div className={styles.rightWrap}>
                    <NewsList content={content.news} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(AreaReports);
